//#region Util Imports

import * as $ from 'jquery'
import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import 'devextreme/ui/load_indicator'
import dxToast, { Options as dxToastOptions } from 'devextreme/ui/toast'
import dxNotify from 'devextreme/ui/notify'
import DevExpress from 'devextreme'
import { CompareRule, CustomRule, RequiredRule, StringLengthRule } from 'devextreme/ui/validation_engine'

//#endregion

import { SERVICE_NAME as IMR_TOAST_SERVICE_NAME } from '@imr/controls.angularjs/services/toast'

import { formatNumber as globalizeFormatNumber, NumberFormatterOptions } from "globalize"

import { OperatorLayoutSettings } from './operator-layout-settings'
import { EntityModel, ColumnModel, FieldModel, SchemaElement, MeasurementModel } from '../modules/api/api.models'
import { i18n } from '../modules/common/i18n/common.i18n'
import { Permissions } from './permissions'
import { EventsNames } from './events-names'
import { LocalDictionaryFactory } from '../modules/api/api.module'
import { DataProvider } from '../helpers/data-provider'
import { IOpObject, IOpData } from '../models/util/interfaces'
import { OpLocationEquipment } from '../models/core/op-location-equipment-old'
import { OpDataType } from '../models/core/op-data-type'
import { OpView } from '../models/core/op-view'
import { Enums } from '../models/common/enums'
import { KnownColor } from '../models/common/known-colors'
import { OpMarker, OpCoord, OpBounds } from '../models/custom/op-map-area'
import { IUserSession } from './user-session'
import { ColumnInfo } from '../models/custom/column-info'
import { SchemaModel, SchemaElementApperance } from '../modules/api/api.models'
import { OpSchema } from '../models/custom/op-schema'
import { OpSchemaElement } from '../models/custom/op-schema-element'
import { ConvertHelper } from './convert-helper'
import { DataTypeFormatter } from '../services/data-type'
import { UserSessionService } from '../services/user-session'
import { OpDataFormatGroupDetails } from '../models/core'
import { TypeHelper } from './type-helper'

// base64 - c#
var base64: any = {}
base64.PADCHAR = '=';
base64.ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

base64.makeDOMException = function () {
	// sadly in FF,Safari,Chrome you can't make a DOMException
	var e, tmp;

	try {
		return new DOMException();
	} catch (ex) {
		// not available, just passback a duck-typed equiv
		// https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error
		// https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Error/prototype
		var ex = new Error("DOM Exception 5");

		// ex.number and ex.description is IE-specific.
		ex.code = ex.number = 5;
		ex.name = ex.description = "INVALID_CHARACTER_ERR";

		// Safari/Chrome output format
		ex.toString = function () { return 'Error: ' + ex.name + ': ' + ex.message; };
		return ex;
	}
}

base64.getbyte64 = function (s, i) {
	// This is oddly fast, except on Chrome/V8.
	//  Minimal or no improvement in performance by using a
	//   object with properties mapping chars to value (eg. 'A': 0)
	var idx = base64.ALPHA.indexOf(s.charAt(i));
	if (idx === -1) {
		throw base64.makeDOMException();
	}
	return idx;
}

base64.decode = function (s) {
	// convert to string
	s = '' + s;
	var getbyte64 = base64.getbyte64;
	var pads, i, b10;
	var imax = s.length
	if (imax === 0) {
		return s;
	}

	if (imax % 4 !== 0) {
		throw base64.makeDOMException();
	}

	pads = 0
	if (s.charAt(imax - 1) === base64.PADCHAR) {
		pads = 1;
		if (s.charAt(imax - 2) === base64.PADCHAR) {
			pads = 2;
		}
		// either way, we want to ignore this last block
		imax -= 4;
	}

	var x = [];
	for (i = 0; i < imax; i += 4) {
		b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i + 1) << 12) |
			(getbyte64(s, i + 2) << 6) | getbyte64(s, i + 3);
		x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff, b10 & 0xff));
	}

	switch (pads) {
		case 1:
			b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i + 1) << 12) | (getbyte64(s, i + 2) << 6);
			x.push(String.fromCharCode(b10 >> 16, (b10 >> 8) & 0xff));
			break;
		case 2:
			b10 = (getbyte64(s, i) << 18) | (getbyte64(s, i + 1) << 12);
			x.push(String.fromCharCode(b10 >> 16));
			break;
	}
	return x.join('');
}

base64.getbyte = function (s, i) {
	var x = s.charCodeAt(i);
	if (x > 255) {
		throw base64.makeDOMException();
	}
	return x;
}

base64.encode = function (s) {
	if (arguments.length !== 1) {
		throw new SyntaxError("Not enough arguments");
	}
	var padchar = base64.PADCHAR;
	var alpha = base64.ALPHA;
	var getbyte = base64.getbyte;

	var i, b10;
	var x = [];

	// convert to string
	s = '' + s;

	var imax = s.length - s.length % 3;

	if (s.length === 0) {
		return s;
	}
	for (i = 0; i < imax; i += 3) {
		b10 = (getbyte(s, i) << 16) | (getbyte(s, i + 1) << 8) | getbyte(s, i + 2);
		x.push(alpha.charAt(b10 >> 18));
		x.push(alpha.charAt((b10 >> 12) & 0x3F));
		x.push(alpha.charAt((b10 >> 6) & 0x3f));
		x.push(alpha.charAt(b10 & 0x3f));
	}
	switch (s.length - imax) {
		case 1:
			b10 = getbyte(s, i) << 16;
			x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
				padchar + padchar);
			break;
		case 2:
			b10 = (getbyte(s, i) << 16) | (getbyte(s, i + 1) << 8);
			x.push(alpha.charAt(b10 >> 18) + alpha.charAt((b10 >> 12) & 0x3F) +
				alpha.charAt((b10 >> 6) & 0x3f) + padchar);
			break;
	}
	return x.join('');
}

// end of base64 - c#

/**
 * Enums.DataType
 */
export enum DataType {
	HELPER_SERIAL_NBR = 10004,
	HELPER_ID_DEVICE_TYPE = 10015,
	HELPER_ID_DEVICE_STATE_TYPE = 10016,
	HELPER_ID_DEVICE_ORDER_NUMBER = 10017,
	HELPER_SERIAL_NBR_PARENT = 10130,
	HELPER_ID_LOCATION = 10002,
	HELPER_ID_METER = 10003,
	HELPER_ID_TASK = 10031,
	HELPER_ID_ISSUE = 10033,
	HELPER_ID_ROUTE = 10095,
	HELPER_ID_PLANNED_ROUTE = 10054,
	HELPER_ID_DEVICE_CONNECTION = 28037,
	HELPER_ID_CONSUMER = 10006,
	HELPER_ID_METER_TYPE = 10018,
	HELPER_ID_REPORT = 10117,
	HELPER_ID_REPORT_TYPE = 10118,
	HELPER_ID_DATA_ARCH = 10109,
	HELPER_ID_ACTION = 10119,
	HELPER_ID_ALARM = 10090,
	HELPER_ID_ALARM_EVENT = 10091,
	LOCATION_NAME = 1,
	LOCATION_ADDRESS = 3,
	LOCATION_CID = 6,
	HELPER_CREATION_DATE = 10058,
	HELPER_ID_ACTION_TYPE = 10120,
	HELPER_ID_ACTION_STATUS = 10121,
	HELPER_ID_OPERATOR = 10032,
	HELPER_ID_MODULE = 10124,
	HELPER_ID_IMR_SERVER = 10089,
	LOCATION_LATITUDE = 7,
	LOCATION_LONGITUDE = 8,
	METER_LATITUDE = 2150,
	METER_LONGITUDE = 2151,
	HELPER_ID_LOCATION_TYPE = 10007,
	HELPER_ID_LOCATION_STATE = 1008,
	HELPER_ID_DISTRIBUTOR = 10005,
	HELPER_ID_LOCATION_STATE_TYPE = 10008,
	DASHBOARD_TILE_TEXT_HEADER = 10152,
	DASHBOARD_TILE_BACKGROUND_COLOR = 10153,
	DASHBOARD_TILE_HOVER_COLOR = 10154,
	DASHBOARD_TILE_SELECT_COLOR = 10155,
	DASHBOARD_TILE_AMOUNT_VISIBLE = 10156,
	DASHBOARD_TILE_TEXT_HEADER_VISIBLE = 10157,
	DASHBOARD_TILE_ICON_VISIBLE = 10158,
	DASHBOARD_TILE_ICON_ID_FILE = 10159,
	DASHBOARD_TILE_BACKGROUND_IMAGE_ID_FILE = 10160,
	DASHBOARD_GAUGE_MIN_VALUE = 10161,
	DASHBOARD_GAUGE_MAX_VALUE = 10162,
	DASHBOARD_GAUGE_TEXT_HEADER = 10163,
	DASHBOARD_GAUGE_RANGE_MIN_VALUE = 10164,
	DASHBOARD_GAUGE_RANGE_MAX_VALUE = 10165,
	DASHBOARD_GAUGE_RANGE_NAME = 10166,
	DASHBOARD_GAUGE_RANGE_COLOR = 10167,
	PROFILE_LOCATION_CUSTOM_FORMAT_STRING = 22259,
	PROFILE_DEVICE_CUSTOM_FORMAT_STRING = 22260,
	PROFILE_METER_CUSTOM_FORMAT_STRING = 22261,
	PROFILE_TASK_CUSTOM_FORMAT_STRING = 22262,
	PROFILE_ISSUE_CUSTOM_FORMAT_STRING = 22263,
	PROFILE_ROUTE_CUSTOM_FORMAT_STRING = 22264,
	PROFILE_REPORT_CUSTOM_FORMAT_STRING = 22265,
	PROFILE_SIM_CARD_CUSTOM_FORMAT_STRING = 22266,
	PROFILE_OPERATOR_CUSTOM_FORMAT_STRING = 22267,
	PROFILE_DISTRIBUTOR_CUSTOM_FORMAT_STRING = 22268,
	HELPER_ROW_COLOR = 28040,
	HELPER_ID_TASK_TYPE = 10067,
	PROFILE_DATE_FORMAT_LONG = 22311,
	PROFILE_DATE_FORMAT_SHORT = 22312,
	PROFILE_MARKER_COLOR = 22270,
	DISTRIBUTOR_LOGO = 17700,
	DISTRIBUTOR_IMPORT_DLL_NAME = 17691,
	HELPER_DICTIONARY_COMPLETENESS = 10147,
	OPERATOR_LOCAL_SETTINGS = 3982,
	TASK_ADDITIONAL_PAYMENT = 17114,
	TASK_CLIENT_ORDERED_TO_PAY = 22589,
	TASK_CLIENT_PAYMENT_AMOUNT = 22590,
	TASK_CLIENT_PAYMENT_DATE = 22591,
	TASK_CLIENT_PAYMENT_DONE = 17102,
	TASK_FITTER_ORDERED_TO_PAY = 22588,
	TASK_FITTER_PAYMENT_DATE = 17107,
	TASK_FITTER_PAYMENT_DONE = 17101,
	TASK_FITTER_VISIT_DATE = 17100,
	TASK_PAYMENT_AMOUNT = 17105,
	TASK_PAYMENT_NOTE = 17106,
	DISTRIBUTOR_DEFAULT_CURRENCY_ID = 17524,
	METER_SERIAL_NUMBER = 2006,
	HELPER_INDEX_NBR = 10217,
	HELPER_TIME = 10131,
	HELPER_ID_DATA_TYPE = 10219,
	HELPER_ID_UNIT = 10216,
	HELPER_VALUE = 10218,
	HELPER_ID_TASK_STATUS = 10057,
	SYSTEM_DICTIONARY_TABLES_VERSION = 7008,
	HELPER_ID_VIEW = 10229,
	HELPER_ID_LANGUAGE = 10082,
	HELPER_ACTION_TARGET = 10205,
	HELPER_ID_DISTRIBUTOR_HIERARCHY = 10250,
	HELPER_ID_ACTOR = 10045,
}

export enum ActionStatus {
	Unknown = 0,
	New = 1,
	Running = 2,
	Succeeded = 3,
	Error = 4,
	Partly = 5,
	Stop = 6,
	Stopped = 7,
	Abort = 8,
	Aborted = 9,
	Waiting = 10,
}

export enum PaymentType {
	Fitter = 1,
	Client = 2,
}

export enum Buttons {
	Unknown = 0,
	Export = 1,
	Import = 2,
	Refresh = 3,
	FullTextSearch = 4,
	AutoFilterRow = 5,
	FitColumns = 6,
	ColumnChooser = 7,
	ColumnConfiguration = 8,
	ProblemConfirmation = 1000,
	PlanDelivery = 1001,
}

export enum SortType {
	None = 0,
	Asc = 1,
	Desc = 2,
}

/**
 * Enums.Module
 */
export enum Module {
	WebSIMAX = 50,
}

/**
 * TimeZoneIdType
 */
export enum TimeZoneIdType {
	Iana = 2,
}

/**
 * Enums.ViewColumnType
 */
export enum ViewColumnType {
	Unknown = 0,
	Standard = 1,
	BaseHelper = 2,
	ExtendedHelper = 3,
}

/**
 * TypeDateTimeCode.ModeType
 */
export enum TypeDateTimeCodeModeType {
	LesserEqual = 5,
	GreaterEqual = 6,
	Between = 1,
}

//Enums.DashboardCardOptions
export enum DashboardCardOptions {
	Unknown = 0,
	Keeper = 1,
	Configuration = 2,
}

export enum DeviceFunctionType {
	Unknown = 0,
	Schedule = 1,
	Alarm = 2,
	Archive = 3,
}

export enum DataTypeClass {
	Unknown = 0,
	Integer = 1,
	Real = 2,
	Text = 3,
	Date = 4,
	Time = 5,
	Datetime = 6,
	Boolean = 7,
	Object = 8,
	Xml = 9,
	Color = 10,
	Binary = 11,
}

//IMR.Suite.Services.WebSimaxInterface.WebSimaxServiceReference.ValidationStatus
export enum ValidationStatus {
	Unknown = 0,
	Correct = 1,
	Incorrect = 2,
	Warning = 3,
}

// Enums.ChartType.XXX - chart types
export class ChartType {
	static Bar = 0
	static StackedBar = 1
	static FullStackedBar = 2
	static Pie = 5
	static Doughnut = 6
	static Line = 11
	static StackedLine = 12
	static FullStackedLine = 13
	static StepLine = 14
	static Area = 18
	static StepArea = 19
	static StackedArea = 21
	static StackedSpline = 23 // TODO
	static StackedSplineArea = 23
	static FullStackedArea = 24
	static FullStackedSpline = 25 // TODO
	static FullStackedSplineArea = 25
}

export class PieChartType {
	static Pie = 5
	static Doughnut = 6
}

//Enums.LocationState
export enum LocationState {
	UNKNOWN = -1,
	UNDEFINED = 0,
	NEW = 1,
	SCHEDULED = 2,
	INTERVENTION = 3,
	PENDING = 4,
	OPERATIONAL = 5,
	SUSPENDED = 6,
	UNUSED = 7,
	DELETED = 8,
	APPROVED = 9,
	READY = 10,
	DISASSEMBLING = 11,
	ASSEMBLED = 12,
	SOLD = 13,
	CANCELED = 14,
	OWNER_CHANGE = 15,
	IN_TRANFER = 16,
	CONTRACT_CHANGE = 17,
	CONTRACT_REWRITE = 18,
	RECONSTRUCTION = 19,
	CONSTRUCTION = 20,
}

//Enums.ImportStatus
export enum ImportStatus {
	Unknown = 0,
	NotStarted = 1,
	Succeded = 2,
	Failed = 3,
	InProgress = 4,
	Validated = 5,
	NotValid = 6,
	Loaded = 7,
	Skipped = 8,
	Cancelled = 9,
}

//Enums.TextAlign
export enum TextAlign {
	Unknown = 0,
	Left = 1,
	Right = 2,
	Center = 3,
	Justify = 4,
}

//Enums.Enums.DashboardCorrelationType
export enum CorrelationType {
	None = 0,
	Local = 1,
	Server = 2,
}

export class FilterNames {
	public static get LocationsByMarkers(): string { return 'LocationFilterByMarkers' }
	public static get DepositoriesByMarkers(): string { return 'DepositoryFilterByMarkers' }
	public static get DeviceConnectionsByLocations(): string { return 'DeviceConnectionFilterByLocations' }
	public static get DevicesByLocations(): string { return 'DeviceFilterByLocations' }
	public static get MetersByLocations(): string { return 'MetersFilterByLocations' }
	public static get TasksByLocations(): string { return 'TaskFilterByLocations' }
}

export class CommonHelper {

	static Base64 = base64
	static toast: dxToast

	//TODO: Do usunięcia po przerobieniu schematów na obiekty Op
	static opSchemaToSchemaModel(schema: OpSchema, userSession: IUserSession) {
		const schemaModel = new SchemaModel()

		if (_.isArray(schema.schema)) {
			schemaModel.schema = ConvertHelper.byteArrayToBase64(schema.schema as number[]) as any
		}
		else {
			schemaModel.schema = schema.schema as any
		}

		schemaModel.height = schema.height
		schemaModel.width = schema.width
		schemaModel.idObject = schema.idObject
		schemaModel.referenceType = schema.referenceType
		schemaModel.class = schema.class
		schemaModel.indexNbr = schema.indexNbr
		schemaModel.schemaConfiguration = this.toSchemaModelElementArr(schema.schemaConfiguration, userSession)

		return schemaModel
	}
	static toSchemaModelElementArr(schemaConfiguration: OpSchemaElement[], userSession: IUserSession): SchemaElement[] {
		var schemaElements = []
		if (schemaConfiguration != null) {
			for (let i = 0; i < schemaConfiguration.length; i++) {
				var sc = schemaConfiguration[i]
				var value = null
				if (sc.value != null || (typeof (sc.value) == "string" && !sc.value)) {
					value = sc.value
				}
				var description = null
				if (sc.descriptionVisible) {
					description = sc.description
				}

				let type: Enums.DataTypeClass = 0
				let dataType: OpDataType = null

				if (sc.idDataType != null) {
					dataType = userSession.getDataProvider().DataType.getDataTypeLocal(sc.idDataType)
				}

				if (dataType != null) {
					type = dataType.idDataTypeClass
				} else {
					if (value != null && typeof (value) == "boolean") {
						type = Enums.DataTypeClass.Boolean
					}
				}
				const schemaElement = new SchemaElement()
				schemaElement.x = sc.x
				schemaElement.y = sc.y
				schemaElement.width = sc.width
				schemaElement.height = sc.height
				schemaElement.name = sc.name
				schemaElement.description = description
				schemaElement.idDataType = sc.idDataType
				schemaElement.isUnitVisible = sc.unitVisible
				schemaElement.type = type
				schemaElement.elementType = sc.elementType
				schemaElement.value = value
				schemaElement.valueHidden = sc.valueHidden
				schemaElement.isEditable = sc.isEditable
				if (sc.schemaElementApperance != null) {
					schemaElement.elementsApperance = []
					for (let j = 0; j < sc.schemaElementApperance.length; j++) {
						var sea = sc.schemaElementApperance[j]
						const schemaElementApperance = new SchemaElementApperance()
						schemaElementApperance.color = sea.color

						if (_.isArray(sea.image)) {
							schemaElementApperance.image = ConvertHelper.byteArrayToBase64(sea.image as number[]) as any
						}
						else {
							schemaElementApperance.image = sea.image as any
						}

						schemaElementApperance.condition = sea.condition,
							schemaElementApperance.constraint1 = sea.constraint1,
							schemaElementApperance.constraint2 = sea.constraint2
						schemaElement.elementsApperance.push(schemaElementApperance)
					}
				}
				else {
					schemaElement.elementsApperance = null
				}
				schemaElements.push(schemaElement)
			}
		}
		return schemaElements
	}

	static stringToCharCodeArr(text: string) {
		var arrSchema = [];
		for (let x = 0; x < text.length; x++) {
			arrSchema[x] = text.charCodeAt(x);
		}
		return arrSchema;
	}

	static handleRejection(apiResourceFactory, statusCode: number, state: any = null, returnThrow: boolean = false, message: string = null) {
		if (statusCode == 503) {
			this.openInfoPopup(message ? message : i18n('Common', 'WebServiceException'), 'error')
		}

		console.log(message, statusCode)

		if (statusCode == 500) {
			this.openInfoPopup(message ? message : i18n('Common', 'ServerException'), 'error')
		}

		else if ((!returnThrow && statusCode == -1 && !state) || (statusCode == -1 && state && !state.cancelled)) {
			this.openInfoPopup(i18n("Common", "ServerException"), "error")
		}

		//disable grid loading
		var bodyElement = angular.element('body')
		var scope: ng.IScope = bodyElement ? bodyElement.scope() : null
		if (scope) {
			scope.$root.$broadcast(EventsNames.SERVER_EXCEPTION_OCCURED)
		}
		//end of disable grid loading

		//disable grid loading
		var bodyElement = angular.element('body')
		var scope: ng.IScope = bodyElement ? bodyElement.scope() : null
		if (scope) {
			scope.$root.$broadcast(EventsNames.SERVER_EXCEPTION_OCCURED)
		}
		//end of disable grid loading

		this.goToLoginPage(apiResourceFactory, statusCode)

		if (true || returnThrow) throw 'ServerException'
	}

	static splitStringWithStringSplitOptions(value: string, splitBy, removeItemString) {
		if (value == '') {
			return new Array()
		}
		var items = value.split(splitBy)

		for (var i = 0; i < items.length; i++) {
			if (items[i] == removeItemString) {
				items.splice(i, 1)
				i--
			}
		}
		return items
	}

	static DBCollectorProperties = {
		InitWebSimaxDataProvider: 5,
		Module: 7,
		Relogin: 14,
		InitTimeZone: 41,
	}

	static LocationType = {
		GroupingLocation: 4,
	}

	static logout() {
		CommonHelper.removeValueFromLocalStorage('USER')
		location.href = '#/login'
		setTimeout(() => {
			window.location.reload()
		}, 100)
	}

	static base64ToImage(base64: string) {
		return 'data:image/png;base64,' + base64
	}

	static bin2String(array: number[]) {
		if (!array) return ''
		var result = ''
		for (var i = 0; i < array.length; i++) {
			result += String.fromCharCode(array[i])
		}
		return btoa(result)
	}

	static string2bin(s: string) {
		let bs = atob(s)
		let a = []
		for (var i = 0; i < bs.length; i++) {
			a[i] = bs.charCodeAt(i)
		}
		return a
	}

	static goToLoginPage(apiResourceFactory, statusCode: number) {
		if (statusCode == 401 || statusCode == 503) {
			var bodyElement = angular.element('body')
			var scope: ng.IScope = bodyElement ? bodyElement.scope() : null
			if (scope) {
				let state = scope.$root['state']

				if (state && ['login', 'logout', 'reset', 'home'].indexOf(state.current.name) < 0) OperatorLayoutSettings.setSetting(OperatorLayoutSettings.StateBeforeAuthRejection, state.current)

				scope.$broadcast('showLoadingIndicator', true)
				scope.$root['hidePage'] = true
			}
			CommonHelper.logout()
		}
	}

	static disableToast = false
	static openInfoPopup(message: string = '', type: string = 'success', displayTime: number = 2000, width: number = 300, additionalOptions?: DevExpress.ui.dxToastOptions) {
		if (additionalOptions == null) {
			const elem = angular.element(document.querySelector('[ng-app="simax"]'))

			if (elem != null) {
				const toastService: any = elem.injector().get(IMR_TOAST_SERVICE_NAME)

				if (toastService != null) {
					switch (type) {
						case 'info': {
							toastService.info(message, {
								displayTime: displayTime,
							})

							break
						}
						case 'error': {
							toastService.error(message, {
								displayTime: displayTime,
							})

							break
						}
						case 'warning': {
							toastService.warning(message, {
								displayTime: displayTime,
							})

							break
						}
						case 'success':
						default: {
							toastService.success(message, {
								displayTime: displayTime,
							})

							break
						}
					}
				}
			}
		} else {
			if (!this.disableToast) {
				if (this.toast) this.toast.hide()

				var toastOptions: dxToastOptions = {
					type: type as 'custom' | 'error' | 'info' | 'success' | 'warning',
					message: message,
					displayTime: displayTime,
					width: width,
					onInitialized: (e) => {
						this.toast = e.component as dxToast
					},
					contentTemplate: (e) => {
						angular.element(e).find('.dx-toast-message').empty().append(message)
					},
				}

				;(<any>Object).assign(toastOptions, additionalOptions)
				dxNotify(toastOptions)
			}
		}
	}

	static debug(value: any) {
		if (window['config'].DEBUG) {
			console.debug(value)
		}
	}

	static closeInfoPopup() {
		if (this.toast) this.toast.hide()
	}

	static createLoadingIndicator(parentEl: JQuery) {
		var div = '<div id="loadingIndicatorGrid" style="display: -ms-flexbox; flex-direction: -ms-column;"></div>'
		var loadingIndicator = '<div id="indicator"></div>'
		parentEl.append(div)
		parentEl
			.find('#loadingIndicatorGrid')
			.css({
				position: 'absolute',
				top: 0,
				left: 0,
				height: '100%',
				width: '100%',
				'z-index': 999,
				background: '#fff',
				display: 'flex',
				'flex-direction': 'column',
				'align-items': 'center',
				'justify-content': 'center',
			})
			.append(loadingIndicator)
		parentEl.find('#indicator').dxLoadIndicator({
			width: 40,
			height: 40,
		})
	}

	static removeLoadingIndicator(parentEl: JQuery) {
		parentEl.find('#loadingIndicatorGrid').remove()
	}

	static objectFromEntityModel(model: EntityModel) {
		var object = {}
		if (model.id) object['id'] = model.id
		if (model.name) object['name'] = model.name
		if (model.referenceId) object['referenceId'] = model.referenceId
		model.fields.forEach((field) => {
			object[field.name.toLowerCase()] = field.value
		})
		return object
	}

	static objectFromObjectModel(model: Object, idLocationEquipment: number = null, serialNbr: number = null, idLocation: number) {
		var object = {}
		if (model['id']) object['id'] = model['id']
		if (model['name']) object['name'] = model['name']
		if (model['referenceId']) object['referenceId'] = model['referenceId']
		if (idLocationEquipment) object['idLocationEquipment'] = idLocationEquipment
		if (serialNbr) object['serialNbr'] = serialNbr
		if (idLocation) object['idLocation'] = idLocation
		var values = model['dynamicValues']
		for (var prop in values) {
			object[prop.toLowerCase()] = values[prop]
		}
		return object
	}

	static devicesFromOpLocationEquipment(equipment: OpLocationEquipment[]) {
		var devices = []
		if (equipment) {
			equipment.forEach((item) => {
				if (item.device) {
					let device = CommonHelper.objectFromObjectModel(item.device, item.idLocationEquipment, item.serialNbr, item.idLocation)
					// TODO: trzeba to sprawdzić albo usunąć metodę devicesFromOpLocationEquipment
					device['name'] = item.device.toString()
					devices.push(device)
				} else {
					let device = item
					device['name'] = item.toString()
					devices.push(device)
				}
			})
		}
		return devices
	}

	static getRequestObject(id: number) {
		var obj = {}
		if (id == 6)
			obj = CommonHelper.prepareRequestObject('device', 'getDevices', 'getDevicesDefaultColumns')
		else if (id == 7)
			obj = CommonHelper.prepareRequestObject('meter', 'getMeters', 'getMeterDefaultColumns')
		else if (id == 8)
			obj = CommonHelper.prepareRequestObject('location', 'getLocations', 'getLocationDefaultColumns')
		else if (id == 11)
			obj = CommonHelper.prepareRequestObject('distributor', 'getDistributors', 'getDistributorDefaultColumns')
		else
			obj = CommonHelper.prepareRequestObject(null, null, null)
		return obj
	}

	static getDataType(column: ColumnModel) {
		switch (column.type) {
			case CommonHelper.integer:
			case CommonHelper.decimal:
			case CommonHelper.real:
				if (column.referenceTypeId) return 'string'
				return 'number'
			case CommonHelper.datetime:
				return 'date'
			case CommonHelper.boolean:
				return 'boolean'
			default:
				return 'string'
		}
	}

	static cellFormatForDifferentValues(
		userSession: UserSessionService,
		options: { value: any; typeId?: number },
		dataType_type: number = null,
		idDataType: number,
		dataTypeFormatter: DataTypeFormatter = null
	): string {
		// Datetime Boolean  Real Integer  Text  Binary Date
		if (options.typeId != null) {
			switch (options.typeId) {
				case CommonHelper.real:
				case CommonHelper.decimal:
				case CommonHelper.integer:
					if (options.value == undefined || options.value == null) {
						return TypeHelper.emptyString
					}

					if (dataTypeFormatter != null) {
						return dataTypeFormatter.formatDisplayValue(options.value, {
							idDataType: idDataType,
							idDataTypeClass: options.typeId,
						})
					}

					let num: any = options.value

					if (!angular.isNumber(num)) {
						const n: number = +num

						if (angular.isNumber(n) && !isNaN(n)) {
							num = n
						} else {
							return num
						}
					}

					return this.formatNumber(userSession, num, idDataType).toString()

				case CommonHelper.string:
					return options.value ? options.value : TypeHelper.emptyString

				case CommonHelper.datetime:
					if (options.value != null) {
						if (dataTypeFormatter != null) {
							return dataTypeFormatter.formatDisplayValue(options.value, {
								idDataType: idDataType,
								idDataTypeClass: Enums.DataTypeClass.Datetime,
							})
						}

						return moment(options.value).format(window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS', idDataType))
					} else {
						return null
					}

				case CommonHelper.date:
					if (options.value != null) {
						if (dataTypeFormatter != null) {
							return dataTypeFormatter.formatDisplayValue(options.value, {
								idDataType: idDataType,
								idDataTypeClass: Enums.DataTypeClass.Date,
							})
						}

						return moment(options.value).format(window['simax'].getDateTimeFormat('DATE_FORMAT_MOMENTJS', idDataType))
					} else {
						return null
					}

				case CommonHelper.boolean:
					if (options.value == null) {
						return null
					}

					if (options.value && options.value.toString().toLowerCase() != 'false') {
						return i18n('Common', 'True')
					} else {
						return i18n('Common', 'False')
					}
			}
		} else {
			if (!dataType_type) {
				//Ask Adam for what all those if-es
				if (moment(options.value, moment.ISO_8601, true).isValid() && dataType_type != CommonHelper.integer && dataType_type != CommonHelper.real) {
					return moment(options.value).format(window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS', idDataType))
				} else if (angular.isNumber(options.value)) {
					return this.formatNumber(userSession, options.value, idDataType)
				} else if (angular.isUndefined(options.value)) {
					return TypeHelper.emptyString
				} else if (options.value == null) {
					return TypeHelper.emptyString
				} else if (options.value.toString() == 'true') {
					return i18n('Common', 'True')
				} else if (options.value.toString() == 'false') {
					return i18n('Common', 'False')
				} else {
					return options.value.toString()
				}
			} else {
				if (angular.isUndefined(options.value)) {
					return TypeHelper.emptyString
				} else if (options.value == null) {
					return TypeHelper.emptyString
				}
				if (moment(options.value, moment.ISO_8601, true).isValid() && dataType_type != CommonHelper.integer && dataType_type != CommonHelper.real) {
					return moment(options.value).format(window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS', idDataType))
				}
				if (dataType_type == CommonHelper.integer || dataType_type == CommonHelper.real) {
					return this.formatNumber(userSession, options.value, idDataType).toString()
				}
				if (dataType_type == CommonHelper.boolean) {
					if (options.value.toString() == 'true') {
						return i18n('Common', 'True')
					} else if (options.value.toString() == 'false') {
						return i18n('Common', 'False')
					}
				}
				return options.value.toString()
			}
		}
	}

	static setJWTCookie(jwt: string) {
		var d = new Date()
		d.setTime(d.getTime() + 5 * 60000)
		var expires = 'expires=' + d.toUTCString()
		document.cookie = 'jwt=' + jwt + ';' + expires + ';path=/'
	}

	private static prepareRequestObject(dataScope: string, dataMethodName: string, dictionaryMethodName: string) {
		return {
			dataScope: dataScope,
			dataMethodName: dataMethodName,
			dictionaryMethodName: dictionaryMethodName,
		}
	}

	static getIcon(icon: string, fill: string = '#000000', size: string = '18') {
		return '<ng-md-icon icon="' + window['config']['ICONS'][icon] + '" style="fill: ' + fill + '" size="' + size + '"></ng-md-icon>'
	}

	static getIconWithText(text: string, icon: string, fill: string = '#000000', size: string = '18') {
		return '<ng-md-icon icon="' + window['config']['ICONS'][icon] + '" style="fill: ' + fill + '" size="' + size + '"></ng-md-icon><span>' + text + '</span>'
	}

	static getIconForDetails(icon: string, fill: string = '#000000', size: string = '18', text: string = null, className: string = '', id = '') {
		return (
			'<div id=' +
			id +
			" class='row " +
			className +
			"'><div class='icon-row'><ng-md-icon icon=" +
			window['config']['ICONS'][icon] +
			' style=fill: ' +
			fill +
			' size=' +
			size +
			'></ng-md-icon></div><span>' +
			' ' +
			text +
			'</span></div>'
		)
	}

	static getIconWithAdditionalIcon(mainIcon: string, icon: string, fill: string = '#000000', size: string = '18') {
		return (
			'<div style="display: flex; flex-direction: row; justify-content: center; align-items: center;"><ng-md-icon icon="' +
			window['config']['ICONS'][mainIcon] +
			'" style="fill: ' +
			fill +
			'" size="' +
			size +
			'"></ng-md-icon><ng-md-icon icon="' +
			window['config']['ICONS'][icon] +
			'" style="position: absolute; right: 2px; bottom: 2px; fill: ' +
			fill +
			'" size="12"></ng-md-icon>' +
			'</div>'
		)
	}

	static getTemplateforListRow(text: string = null, className: string = '', id = '', icon: string = null) {
		if (!icon) return '<div id=' + id + " class='row " + className + "'><div class='icon-row'></div><span>" + ' ' + text + '</span></div>'
		else return '<div id=' + id + " class='row " + className + "'><div class='icon-row'>" + this.getIcon(icon) + '</div><span>' + ' ' + text + '</span></div>'
	}

	static checkResultError(result: any) {
		if (result.hasErrorCode && result.hasErrorCode > 0) {
			this.openInfoPopup(this.getErrorMessage(result.hasErrorCode, result.errorMessage), 'error', 5000)
		} else {
			return result
		}
	}

	static getErrorMessage(code: any, msg: any) {
		if (code && code >= 0) {
			if (msg) return msg
			else
				switch (code) {
					case 0:
						return i18n('Common', 'SqlError')

					case 1:
						return i18n('Common', 'AccountBlockedError')

					case 2:
						return i18n('Common', 'InvalidAccountNameOrPasswordError')

					case 3:
						return i18n('Common', 'AccountLoginPermissionDeniedError')

					case 4:
						return i18n('Common', 'MissingParametersError')

					case 5:
						return i18n('Common', 'ExceptionOccurredError')

					case 6:
						return i18n('Common', 'InsufficientPermissionsError')

					case 7:
						return i18n('Common', 'UnknownComponentError')

					case 8:
						return i18n('Common', 'InitializationError')

					case 9:
						return i18n('Common', 'IdsNotMappedError')

					case 10:
						return i18n('Common', 'ServerNotFoundError')

					case 11:
						return i18n('Common', 'MSMQParamsNotFoundError')

					default:
						return i18n('Common', 'WebServiceException')
				}
		}
	}

	static createWhereForReferenceGrid(columns: ColumnModel[], reqWhere: string) {
		var where = ''

		var value = reqWhere.split('%')[1]

		columns.forEach((col) => {
			if (where.length > 0) {
				where += ' OR '
			}

			where += '[' + col.name + "] like '%" + value + "%'"
		})

		return where
	}

	static capitalizeFirstLetter(text: string) {
		return text.charAt(0).toUpperCase() + text.slice(1)
	}

	static betweenDateFilterMinVal(e, startPlaceholder, timeout, endDateBoxArray) {
		if (e.component._options.placeholder == startPlaceholder && e.component._options.value) {
			timeout(() => {
				if (endDateBoxArray) {
					var element = endDateBoxArray.filter((endDateBox) => {
						return endDateBox.component.option('accessKey') == e.component.option('accessKey')
					})[0]
					if (element && element.component) {
						var endDateBoxComponent = element.component
						endDateBoxComponent.option('min', e.component.option('value'))
					}
				}
			})
		}
	}

	static betweenDateFilterMaxVal(e, endPlaceholder, timeout, startDateBoxArray) {
		if (e.component._options.placeholder == endPlaceholder && e.component._options.value) {
			timeout(() => {
				if (startDateBoxArray) {
					var element = startDateBoxArray.filter((startDateBox) => {
						return startDateBox.component.option('accessKey') == e.component.option('accessKey')
					})[0]
					if (element && element.component) {
						var startDateBoxComponent = element.component
						startDateBoxComponent.option('max', e.component.option('value'))
					}
				}
			})
		}
	}

	static setFocusOnWindow() {
		angular.element('body').focus()
	}
	static setFocusOnTab(tabs) {
		_.forEach(tabs, (tab: any) => {
			var foundElement = _.find(tab.classList, (className) => {
				return className == 'dx-tab-selected'
			})

			if (foundElement) {
				$(tab).addClass('dx-state-focused')
			}
		})
	}

	static reportType = {
		jobReport: 7,
		serverReportingServices: 8,
	}

	static formatNumber(userSession: UserSessionService, value: number, idDataType: number | string = null) {
		if (value == null) {
			return ''
		}

		const formatGroup: OpDataFormatGroupDetails[] = userSession.getDataProvider().LocalStorage.getLoggedOperatorSetting(Enums.SimaxOperatorSetting.DataTypeFormatGroup) || []
		if (value != null && _.size(formatGroup) > 0) {
			const formatData: OpDataFormatGroupDetails[] = formatGroup.filter((item: OpDataFormatGroupDetails) => item.idDataType == idDataType)

			if (formatData.length > 0 && formatData[0].dataTypeFormatOut != null) {
				const format: string = formatData[0].dataTypeFormatOut.datetimeFormat || '' //strange but that field used on thin client. need to check but dont remember necessary server
				//not sure that globalizeOptions is correct and works fine. it should be type of NumberFormatterOptions and there is no 'raw' field
				const globalizeOptions: NumberFormatterOptions = <NumberFormatterOptions>{ raw: format }

				return globalizeFormatNumber(value, globalizeOptions)
			} else {
				const dataType: OpDataType = userSession.getDataProvider().DataType.getDataTypeLocal(+idDataType) // window['simax'].getDataType(idDataType)

				if (dataType != null) {
					const dtFormat: string =
						(dataType.idDataTypeClass == Enums.DataTypeClass.Real || dataType.idDataTypeClass == Enums.DataTypeClass.Integer || dataType.idDataTypeClass == Enums.DataTypeClass.Decimal) &&
						dataType.dataTypeFormat
							? dataType.dataTypeFormat.datetimeFormat
							: null

					if (dtFormat != null) {
						const globalizeOptions: NumberFormatterOptions = <NumberFormatterOptions>{ raw: dtFormat }

						return globalizeFormatNumber(value, globalizeOptions)
					}
				}
			}
		}
		return globalizeFormatNumber(value)
	}

	static distinct<T>(toDistinct: T[]): T[] {
		if (!toDistinct || toDistinct.length == 0) return toDistinct
		return toDistinct.reduce((prev, cur) => (prev.indexOf(cur) < 0 ? prev.concat([cur]) : prev), [])
	}

	static getIdDataTypesFromObjectList<T extends IOpObject>(objectList: T[]): number[] {
		var result: number[] = []
		if (objectList && objectList.length > 0) {
			var unique = {}
			objectList.forEach((obj) => {
				if (obj.dataList && obj.dataList.length > 0) {
					obj.dataList.toArray().forEach((dataType: IOpData) => {
						if (!unique[dataType.idDataType]) {
							unique[dataType.idDataType] = dataType.idDataType
							result.push(dataType.idDataType)
						}
					})
				}
			})
		}
		return result
	}

	static getHashCode(toHash: string): number {
		return toHash.split('').reduce(function (a, b) {
			a = (a << 5) - a + b.charCodeAt(0)
			return a & a
		}, 0)
	}

	static datetime = 6
	static date = 4
	static time = 5
	static string = 3
	static real = 2
	static boolean = 7
	static integer = 1
	static decimal = 12
	static binary = 11
	static text = 3
	static xml = 9

	static greaterThan = '>'
	static lowerThan = '<'
	static greaterOrEqual = '>='
	static lowerOrEqual = '<='
	static equal = '=='
	static notEqual = '!='
	static idField = 'id'
	static nameField = 'name'
	static serialNumberField = 'serialNbr'
	static serialNumberParentField = 'serialNbrParent'
	static idReferenceField = 'referenceId'

	static locationColumnId = 10002
	static locationTypeColumnId = 10007
	static locationStateType = 10008
	static locationName = 1
	static locationCity = 2
	static locationAddress = 3
	static locationZip = 4
	static locationLatitude = 7
	static locationLongitude = 8
	static locationPatternColumnId = 10148

	static meterColumnId = 10003
	static meterPatternColumnId = 10150

	static issuesColumnId = 10033

	static tasksColumnId = 10031
	static taskGroupColumnId = 10053

	static alarmsColumnId = 10090
	static alarmsName = 10108

	static userColumnId = 10032
	static actorColumnId = 10045
	static userColumnLogin = 10047
	static userColumnPassword = 10049
	static contactGroupId = 10125

	static distributorColumnId = 10005
	static descriptionColumnId = 10083
	static nameColumnId = 10074
	static isEnabledColumnId = 10146

	static priorityColumnId = 10065
	static taskStatusColumnId = 10057
	static registerOperatorColumnId = 10055
	static issueStatusColumnId = 10070

	static routeId = 10095

	static simcardId = 28029
	static simcardTariffColumnId = 28001
	static simcardOperatorTariffColumnId = 28020

	static actionColumnId = 0
	static gridDateColumnId = 10104
	static moduleColumnId = 10124
	static executeOperatorColumnId = 10100

	static depositoryColumnId = 17005

	static nonTranslatedDataTypes = [
		DataType.HELPER_ID_ACTION,
		DataType.HELPER_ID_ALARM,
		DataType.HELPER_ID_ALARM_EVENT,
		DataType.HELPER_ID_CONSUMER,
		DataType.HELPER_ID_DATA_ARCH,
		DataType.HELPER_ID_DEVICE_CONNECTION,
		DataType.HELPER_ID_ISSUE,
		DataType.HELPER_ID_LOCATION,
		DataType.HELPER_ID_METER,
		DataType.HELPER_ID_PLANNED_ROUTE,
		DataType.HELPER_ID_REPORT,
		DataType.HELPER_ID_ROUTE,
		DataType.HELPER_ID_TASK,
		DataType.HELPER_SERIAL_NBR,
		DataType.HELPER_SERIAL_NBR_PARENT,
		DataType.HELPER_ID_DISTRIBUTOR,
		DataType.HELPER_ID_ACTOR,
	]

	// Enums.ReferenceType.XXX (backend)
	static IdLocation = 8
	static IdLocationType = 40
	static IdAlarmEvent = 114
	static IdDistributor = 11
	static IdAction = 102
	static IdActor = 73
	static IdRoute = 20
	static IdOperator = 1
	static IdSimCard = 70
	static IdDevice = 6
	static IdDataType = 5
	static IdDeviceConnection = 112
	static IdDeviceType = 14
	static IdMeter = 7
	static IdTask = 66
	static IdIssue = 65
	static IdMeterTypeClass = 51
	static IdChartType = 93
	static IdReport = 3
	static IdAlarmGroup = 89
	static IdAlarmType = 95
	static IdAlarmDef = 96
	static IdTaskGroup = 63
	static IdTariff = 43
	static Color = 125
	static IdProfile = 30
	static RoleHelperId = 10116
	static IdDescr = 46
	static IdDepositoryElement = 78
	static IdLanguage = 25
	static IdDistributorHierarchy = 140
	static IdConsumer = 138
	static IdConfigurationProfile = 42

	static actionTypeColumnId = 10120
	static actionStatusColumnId = 10121

	static action = 'action'
	static alarm = 'alarm'
	static device = 'device'
	static distributor = 'distributor'
	static issue = 'issue'
	static location = 'location'
	static meter = 'meter'
	static route = 'route'
	static task = 'task'
	static user = 'user'
	static simcard = 'simcard'
	static contact = 'contact'
	static report = 'report'
	static alarmsGroup = 'alarmsGroup'
	static scripts = 'scripts'

	static mainGrid = 'mainGrid'
	static paginatedSmallGrid = 'paginatedSmallGrid'
	static smallGrid = 'smallGrid'
	static createEditGrid = 'createEditGrid'
	static noSearchBarSmallGrid = 'noSearchBarGrid'
	static noSearchBarPaginatedSmallGrid = 'noSearchBarPaginatedSmallGrid'

	static normalMarkerId = -1
	static deviceMarkerId = 0
	static parentMarkerId = 1
	static deviceWithoutParentMarkerId = 2
	static deviceWithParentMarkerId = 3
	static importInPopup = true

	static filterSelection = 'filterSelection'

	static dispatcherIndex = 0
	static dispatcherFunction = 1

	static FILTERED_COLUMN: string = 'FILTERED_COLUMN'
	static FILTER_TEXT: string = 'FILTER_TEXT'
	static FILTER_LABEL: string = 'FORM_ITEMS'
	static LAST_SELECTED_ROW: string = 'LAST-SELECTED_ROW'
	//saved in operator settings from scripts module
	static FAVORITE_SCRIPTS: string = 'FAVORITE_SCRIPTS'
	static RECENT_SCRIPTS: string = 'RECENT_SCRIPTS'
	//dispatcher function indices - values cannot duplicate !!!
	static crtlAGridEditFunc = 0
	static allowedDistributors = 'ALLOWED_DISTRIBUTORS'
	static isAllModulesAllowed = 'IS_ALL_MODULES_ALLOWED'

	static webSIMAXModuleId = 50

	static localStorageVarForSavedEntity = {
		actorSaved: 'actorSaved',
		alarmGroupSaved: 'alarmGroupSaved',
		bulkSaved: 'bulkSaved',
		consumerSaved: 'consumerSaved',
		consumerTypeSaved: 'consumerTypeSaved',
		contactSaved: 'contactSaved',
		depositorySaved: 'depositorySaved',
		depositoryMinimumStates: 'depositoryMinimumStates',
		deviceSaved: 'deviceSaved',
		distributorSaved: 'distributorSaved',
		groupingLocationSaved: 'groupingLocationSaved',
		groupingLocationTypeSaved: 'groupingLocationTypeSaved',
		issueSaved: 'issueSaved',
		locationSaved: 'locationSaved',
		locationParamGrid: 'locationSavedParamGrid',
		meterSaved: 'meterSaved',
		reportSaved: 'reportSaved',
		routeSaved: 'routeSaved',
		simcardSaved: 'simcardSaved',
		tariffSaved: 'tariffSaved',
		taskSaved: 'taskSaved',
		taskTypeSaved: 'taskTypeSaved',
		userSaved: 'userSaved',
		operatorGroupSaved: 'operatorGroupSaved',
		orderSaved: 'orderSaved',
		packageSaved: 'packageSaved',
		supplierSaved: 'supplierSaved',
	}

	static domain = location.pathname.replace(/\\/g, '').replace('/', '').toUpperCase()

	private static settings = null
	private static localStorageTimeout = null

	private static getSettingsFromLocalStorage() {
		if (!this.settings) {
			var settings = {}
			var lastLocalStorage = localStorage.getItem(CommonHelper.domain + 'SETTINGS')
			if (lastLocalStorage) {
				settings = JSON.parse(lastLocalStorage)
			}
			this.settings = settings
		}
		return this.settings
	}

	private static saveSettingsToLocalStorage(time = 1000): JQueryPromise<boolean> {
		const deferred: JQueryDeferred<boolean> = $.Deferred<boolean>()

		if (this.localStorageTimeout) {
			clearTimeout(this.localStorageTimeout)
		}

		const doSave = () => {
			try {
				localStorage.setItem(CommonHelper.domain + 'SETTINGS', JSON.stringify(this.settings))

				return true
			} catch (e) {
				console.warn('Unable to save settings:', e)

				return false
			}
		}

		if (time >= 0) {
			this.localStorageTimeout = setTimeout(() => {
				deferred.resolve(doSave())
			}, time)
		} else {
			deferred.resolve(doSave())
		}

		return deferred.promise()
	}

	static checkLocalStorageUsage() {
		let settingsKeys = []
		for (let key in localStorage) {
			if (key.indexOf('SETTINGS') > -1) settingsKeys.push(key)
		}

		if (settingsKeys.length > 4) {
			let oldest = {
				key: settingsKeys[0],
				date: null,
			}

			for (let index in settingsKeys) {
				const key = settingsKeys[index]

				const settings = localStorage.getItem(key)
				if (!oldest.date || !settings['DATE'] || settings['DATE'] < oldest.date) {
					oldest.date = settings['DATE']
					oldest.key = key
				}
			}

			CommonHelper.clearLocalStorage(oldest.key)
		}
	}

	static clearLocalStorage(key?: string) {
		localStorage.removeItem(CommonHelper.domain + (key || 'SETTINGS'))
		if (!key) {
			CommonHelper.clearLoadedSettings()
		}
	}

	static clearLoadedSettings() {
		this.settings = null
	}

	static setValueToLocalStorage(name: string, value: any, time = 1000): JQueryPromise<boolean> {
		var settings = this.getSettingsFromLocalStorage()
		settings[name] = value

		return this.saveSettingsToLocalStorage(time)
	}

	static getValueFromLocalStorage(name: string) {
		var settings = this.getSettingsFromLocalStorage()
		var value = settings[name]
		if (typeof value === 'undefined') value = null
		return value
	}

	static removeValueFromLocalStorage(name: string, time: number = 0): JQueryPromise<boolean> {
		var settings = this.getSettingsFromLocalStorage()
		delete settings[name]

		return this.saveSettingsToLocalStorage(time)
	}

	static rbgaToRgbColor(color: string) {
		var rgbRegex = /\d{1,3},\d{1,3},\d{1,3}/g

		var matched = color.match(rgbRegex)

		return matched ? matched[0] : ''
	}

	static argbToRGB(color) {
		return '#' + ('000000' + (color & 0xffffff).toString(16)).slice(-6)
	}

	static rgbaToHexColor(color: string) {
		var splitted = color.split(',')
		var hex = '#'
		for (let i = 0; i < 3; i++) {
			hex += parseInt(splitted[i]).toString(16)
		}
		return hex
	}

	static rgbToHex(rgb: any[]): string {
		var hex = rgb
			.slice(0, 3)
			.map((c) => {
				var h = parseInt(c).toString(16)
				return h.length == 1 ? '0' + h : h
			})
			.join('')
		return hex
	}

	static hexToRgbaColor(hex: string): string {
		if (!hex) return ''

		var result: string = '',
			digitValue
		hex = hex.toLowerCase().replace('#', '')
		for (let i = 0; i < hex.length; i += 2) {
			digitValue = '0123456789abcdefgh'.indexOf(hex[i])
			let singleNumber = 0
			singleNumber = digitValue

			digitValue = '0123456789abcdefgh'.indexOf(hex[i + 1])
			singleNumber = singleNumber * 16 + digitValue

			result += singleNumber + ','
		}

		result += '255'

		return result
	}

	static fileExtensionsToMediaTypes(extensions: string[]) {
		var result = ''
		_.forEach(extensions, (extension) => {
			switch (extension) {
				case 'xls':
					result += 'application/vnd.ms-excel,'
					break
				case 'xlsx':
					result += 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,'
					break
				case 'csv':
					result += 'text/csv,'
					break
				case 'xml':
					result += 'application/xml,'
					break
				case 'png':
					result += 'image/png,'
					break
				case 'jpg':
				case 'jpeg':
					result += 'image/jpeg,'
					break
				case 'svg':
					result += 'image/svg+xml,'
					break
			}
		})
		return result
	}

	static getFileExtension(fileName: string) {
		return fileName.split('.').pop()
	}

	static convertDataURIToBinary(dataURI) {
		var base64_marker = ';base64,'
		var base64Index = dataURI.indexOf(base64_marker) + base64_marker.length
		var base64 = dataURI.substring(base64Index)
		var raw = window.atob(base64)
		var rawLength = raw.length
		var array = []

		for (var i = 0; i < rawLength; i++) {
			array.push(raw.charCodeAt(i))
		}
		return array
	}

	static logoutFromApp($scope: ng.IScope, userSession: IUserSession) {
		$scope.$root.$broadcast('showLoadingIndicator')
		userSession.saveOperatorLayoutSettings(0, true, () => {
			CommonHelper.disableToast = true

			CommonHelper.removeValueFromLocalStorage('USER', -1).then((success: boolean) => {
				if (!success) {
					console.warn('Unable to logout due to a localStorage error. Forcing logout')

					localStorage.clear()
				}

				location.reload()
			})

			// Last chance
			setTimeout(() => {
				console.error('There was a problem logging out, please contact with the administrator')
				localStorage.clear()
				location.reload()
			}, 10000)
		})
	}

	static ChangeState = {
		Undefined: 0,
		New: 1,
		Modified: 2,
		Loaded: 3,
		Delete: 4,
		Incorrect: 5,
	}

	static LocationStateType = {
		Deleted: 8,
	}

	static DashboardItemType = {
		Tile: 0,
		Gauge: 1,
		Chart: 2,
		Grid: 3,
		Card: 4,
		Map: 5,
		Schema: 6,
	}

	static getAttachmentButtonColumn(scope: any, eventName: string) {
		var column = <any>{
			id: 'attachmentObject',
			idName: 'attachmentObject',
			cellTemplate: (container, options) => {
				let div = $('<div class="attachment-object-container"></div>')
				div.appendTo(container)

				let buttonOptions = {
					hint: i18n('Common', 'GetAttachment'),
					icon: 'fa fa-download',
					onClick: (e) => {
						scope.$root.$broadcast(eventName, options.data.id)
					},
				}
				let button = $('<div class="attachment-object-button small-button dx-button-has-icon"></div>')
				button.dxButton(buttonOptions)
				button.appendTo(div)
			},
			caption: '',
			name: '',
			referenceTypeId: null,
			sortDesc: false,
			type: 0,
			unitId: null,
			unitName: '',
			where: null,
			isEditable: false,
			alignment: 'center',
			allowSorting: false,
			width: 50,
			allowResizing: false,
		}
		return column
	}

	static regexMicrosoftDate = /\/Date\([0-9]+(\+[0-9]+)?\)\//

	// args = " param1=value1 parma2=value2  paramN=valueN"
	// ret=  [ {arg:param1, value:value1}, {arg:paramN, value:valueN} ]
	static getParamsArrayFromString(args: string) {
		var ret = []
		if (args) {
			var commingArgs = args.trim().split(' ')
			commingArgs.forEach((params) => {
				var par = params.trim().split('=')
				if (par && par.length >= 2) {
					ret.push({ arg: par[0].trim(), value: par[1].trim() })
				}
			})
		}
		return ret
	}

	static SchemaElementType = {
		Unknown: 0,
		StandardInput: 1,
		Redirection: 2,
	}

	static fetchFromObject(obj, prop) {
		if (typeof obj === 'undefined') {
			return false
		}

		var _index = prop.indexOf('.')
		if (_index > -1) {
			return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1))
		}

		return obj[prop]
	}

	static setPropertyInObject(obj, property: string, value) {
		if (!obj || !property) return
		let props = property.split('.')
		let prop = props.slice(0, props.length - 1).reduce((prev, current) => {
			return prev[current]
		}, obj)

		prop[props[props.length - 1]] = value
	}

	static getReferenceSettings(
		dataProvider: DataProvider,
		idReferenceType: Enums.ReferenceType,
		idDataType: number,
		localDictionary: LocalDictionaryFactory,
		moduleReferenceType: number = null
	): { settings?: { dictionaryMethod: string }; isSelectGrid: boolean } {
		let settings: { dictionaryMethod: string } = null
		let isSelectGrid: boolean = false

		if (
			moduleReferenceType &&
			moduleReferenceType === idReferenceType &&
			moduleReferenceType !== Enums.ReferenceType.IdLocation /*for showing <select-popover> for location selection while import on location module*/
		) {
			return { settings, isSelectGrid }
		}
		if (window['config'].USE_REST_API) {
			//W tym miejscu Aktywne widoku już muszą być pobrane (są zapewniane podczas logowania), nie trzeba więc promisa stosować
			var activeView: OpView = dataProvider.View.getActiveViewLocal(idReferenceType)
			if (activeView) {
				isSelectGrid = true
			}
		} else {
			if (idReferenceType == CommonHelper.IdLocation && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdLocation)) {
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdDistributor) {
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdMeter && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdMeter)) {
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdDevice && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdDevice)) {
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdActor && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdActor)) {
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdTaskGroup && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdTaskGroup)) {
				settings = { dictionaryMethod: 'getTaskGroupSelectColumns' }
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdTariff && idDataType == CommonHelper.simcardTariffColumnId && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdTariff)) {
				settings = { dictionaryMethod: 'getSimcardTariffSelectColumns' }
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdTariff && idDataType == CommonHelper.simcardOperatorTariffColumnId && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdTariff)) {
				settings = { dictionaryMethod: 'getSimcardOperatorTariffSelectColumns' }
				isSelectGrid = true
			}
			if (idReferenceType == CommonHelper.IdOperator && !localDictionary.isReferenceTableInLocalDictionary(CommonHelper.IdOperator)) {
				isSelectGrid = true
			}
		}
		return { settings, isSelectGrid }
	}

	static permissionForMainModuleColumnsReordering(idReference: number) {
		var permission = ''
		switch (idReference) {
			case CommonHelper.IdTask:
				permission = Permissions.TASK_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdIssue:
				permission = Permissions.ISSUE_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdLocation:
				permission = Permissions.LOCATION_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdDevice:
				permission = Permissions.DEVICE_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdMeter:
				permission = Permissions.METER_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdActor:
				permission = Permissions.ACTOR_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdOperator:
				permission = Permissions.OPERATOR_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdDistributor:
				permission = Permissions.DISTRIBUTOR_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdRoute:
				permission = Permissions.ROUTE_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdAlarmEvent:
				permission = Permissions.ALARM_EVENT_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdSimCard:
				permission = Permissions.SIMCARD_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdReport:
				permission = Permissions.REPORT_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdAction:
				permission = Permissions.ACTION_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdDeviceConnection:
				permission = Permissions.DEVICE_CONNECTION_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
			case CommonHelper.IdAlarmGroup:
				permission = Permissions.ALARM_GROUP_MODULE_MAIN_GRID_COLUMN_REORDER_DISALLOWED
				break
		}
		return permission
	}

	static Services = {
		tasks: 'tasksService',
		history: 'historyService',
		devices: 'devicesService',
		dashboard: 'dashboardService',
	}

	// get marker from row or details
	static getMarkerFromData(data: any, onClick: (id: number, marker: OpMarker) => void = null): OpMarker {
		var id: number = data.id
		var pos: OpCoord = null

		if (data.hasOwnProperty('latitude') || data.hasOwnProperty('longitude')) {
			// normal markers - standard
			var latitude = +data.latitude
			var longitude = +data.longitude
			if (!isNaN(latitude) && !isNaN(longitude)) {
				pos = new OpCoord()
				pos.latitude = latitude
				pos.longitude = longitude
			}
		}

		// add marker
		if (pos) {
			var marker = new OpMarker()
			marker.coords = pos
			marker.referenceValue = id

			// get marker tooltip
			if (data.tooltip) marker.tooltip = data.tooltip
			else if (data.markerString) marker.tooltip = data.markerString
			else marker.tooltip = id.toString()

			// get marker icon or color
			if (data.markerColorReference) {
				var rgbIconColor = KnownColor.getColor(data.markerColorReference.toString())
					.split(',')
					.map((c) => +c)
				marker.fillColor = CommonHelper.rgbToHex(rgbIconColor)
			}

			marker.onClick = (element: OpMarker) => {
				if (onClick) onClick(id, marker)
			}

			return marker
		}
		return null
	}

	static getLonLatFilter(bounds: OpBounds, latColName: string, lonColName: string, filterName: string): any {
		var filter: any = [
			[latColName, '>=', bounds.southWest.latitude],
			'AND',
			[latColName, '<=', bounds.northEast.latitude],
			'AND',
			[lonColName, '>=', bounds.southWest.longitude],
			'AND',
			[lonColName, '<=', bounds.northEast.longitude],
		]
		filter.stack = true
		filter.filterName = filterName
		return filter
	}

	static convertToColumnInfo(columns: ColumnModel[]): ColumnInfo[] {
		var result: ColumnInfo[] = []
		if (columns && columns.length > 0) {
			columns.forEach((column) => {
				result.push(new ColumnInfo(column))
			})
		}
		return result
	}

	static convertDataTypeToFieldModel(dataTypes: OpDataType[]): FieldModel[] {
		//DO USUNIECIA!!! - kiedy pozbędziemy się FieldModel
		let result: FieldModel[] = []
		if (dataTypes) {
			dataTypes.forEach((dataType) => {
				var field: FieldModel = new FieldModel()
				field.caption = dataType.toString()
				field.format = <any>dataType.dataTypeFormat
				field.idDataType = dataType.idDataType
				field.isEditable = dataType.isEditable
				field.name = dataType.idDataType + ''
				field.referenceTypeId = dataType.idReferenceType
				field.typeId = dataType.idDataTypeClass
				field.type = dataType.dataTypeClass.name
				field.unitName = dataType.unit.name
				field['orderNbr'] = null
				field.valueReferenceId = dataType.idReferenceType
				field.value = dataType.defaultValue

				result.push(field)
			})
		}
		return result
	}

	//#region Validation rules for password form item

	static requiredField(): RequiredRule {
		return {
			type: 'required',
			message: i18n('Common', 'RequiredField'),
		}
	}

	static minLenghtField(minLength: number = 8, ignoreEmptyValue: boolean = false): StringLengthRule {
		return {
			type: 'stringLength',
			min: minLength,
			ignoreEmptyValue: ignoreEmptyValue,
			message: `${i18n('Common', 'RequiredMinCharactersCount')}: ${minLength}`,
		}
	}

	static compareField(comparisonTarget: () => any): CompareRule {
		return {
			type: 'compare',
			message: i18n('Common', 'PasswordsDontMatch'),
			comparisonTarget: comparisonTarget,
		}
	}

	static minLowerCaseField(minLength: number, ignoreEmptyValue: boolean = false): CustomRule {
		return {
			type: 'custom',
			message: `${i18n('Common', 'RequiredMinLowerCaseCharactersCount')}: ${minLength}`, // i18n('Common', 'PasswordsDontMatch'),
			reevaluate: true,
			ignoreEmptyValue: ignoreEmptyValue,
			validationCallback: (e: any) => {
				let count: number = 0

				_.forEach(e.value, (char: string) => {
					if (!TypeHelper.isNumber(char) && !TypeHelper.isSpecialSimbol(char) && TypeHelper.isLowerCase(char)) {
						count++
					}
				})

				return count >= minLength
			},
		}
	}

	static minUpperCaseField(minLength: number, ignoreEmptyValue: boolean = false): CustomRule {
		return {
			type: 'custom',
			message: `${i18n('Common', 'RequiredMinUpperCaseCharactersCount')}: ${minLength}`, // i18n('Common', 'PasswordsDontMatch'),
			reevaluate: true,
			ignoreEmptyValue: ignoreEmptyValue,
			validationCallback: (e: any) => {
				let count: number = 0

				_.forEach(e.value, (char: string) => {
					if (!TypeHelper.isNumber(char) && !TypeHelper.isSpecialSimbol(char) && TypeHelper.isUpperCase(char)) {
						count++
					}
				})

				return count >= minLength
			},
		}
	}

	static minNumbersField(minLength: number, ignoreEmptyValue: boolean = false): CustomRule {
		return {
			type: 'custom',
			message: `${i18n('Common', 'RequiredMinNumbersCount')}: ${minLength}`, // i18n('Common', 'PasswordsDontMatch'),
			reevaluate: true,
			ignoreEmptyValue: ignoreEmptyValue,
			validationCallback: (e: any) => {
				let count: number = 0

				_.forEach(e.value, (char: string) => {
					if (TypeHelper.isNumber(char)) {
						count++
					}
				})

				return count >= minLength
			},
		}
	}

	static minSpecialSymbolsField(minLength: number, ignoreEmptyValue: boolean = false): CustomRule {
		return {
			type: 'custom',
			message: `${i18n('Common', 'RequiredMinSpecialSymbolsCount')}: ${minLength}`, // i18n('Common', 'PasswordsDontMatch'),
			reevaluate: true,
			ignoreEmptyValue: ignoreEmptyValue,
			validationCallback: (e: any) => {
				let count: number = 0

				_.forEach(e.value, (char: string) => {
					if (TypeHelper.isSpecialSimbol(char)) {
						count++
					}
				})

				return count >= minLength
			},
		}
	}
	//#endregion
}
